
<template>
     <div class="waterSpace"></div>
</template>

<script>
// 用于作为系统中页面间隔水槽
export default {

}
</script>

<style lang="scss" scoped>
.waterSpace{
    width:calc(100% + 32px);
    height: 24px;
    background-color: #F5F5F5;
    margin-left: -16px;
}
</style>